export const changeWallpaper = wallpaperType =>{
    return dispatch => dispatch({ type: 'CHANGE_WALLPAPER', wallpaperType });
};